import axios from 'axios';
import demoAdapter from './demoAdapter';

// Local development must also work when opened from another device on the LAN.
const configuredUrl = process.env.REACT_APP_API_URL;
const apiUrl = new URL(configuredUrl || 'http://localhost:3001/api/v1', window.location.origin);
if (['localhost', '127.0.0.1'].includes(apiUrl.hostname) &&
    !['localhost', '127.0.0.1'].includes(window.location.hostname)) {
  apiUrl.hostname = window.location.hostname;
}
const api = axios.create({
  baseURL: apiUrl.toString(),
  ...(process.env.REACT_APP_DEMO_MODE === 'true' ? { adapter: demoAdapter } : {}),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const authAttemptPaths = ["/auth/login", "/auth/send-otp", "/auth/verify-otp"];
    const isAuthAttempt = authAttemptPaths.includes(error.config?.url);
    // A 401 from a login attempt means invalid credentials, not an expired
    // signed-in session. Keep the user on the form so it can show its error.
    if (error.response?.status === 401 && !isAuthAttempt && localStorage.getItem('authToken')) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      window.location.href = '/LoginNumber';
    }
    return Promise.reject(error);
  }
);

export default api;
